interface Args {
  inputTokens: number;
  outputTokens: number;
  inputPrice: number;
  outputPrice: number;
}

export function estimateRunCost(a: Args): number {
  const raw =
    (a.inputTokens / 1_000_000) * a.inputPrice + (a.outputTokens / 1_000_000) * a.outputPrice;
  return Math.round(raw * 10000) / 10000;
}

/** Estimate tokens for a UI-strings translate (very rough). */
export function estimateUiTokens(keyCount: number): { input: number; output: number } {
  // Heuristic: ~50 input tokens per key (label + key name + prompt overhead);
  // ~30 output tokens per translated value.
  return { input: keyCount * 50, output: keyCount * 30 };
}

/** Estimate tokens for a topics translate. */
export function estimateTopicTokens(topicCount: number): { input: number; output: number } {
  // Per topic: ~500 in + ~400 out
  return { input: topicCount * 500, output: topicCount * 400 };
}
